import React from 'react';
const CoralKarbala = () => { return (<div className="container mx-auto p-8 text-center bg-white shadow-md rounded-lg mt-8"><h1 className="text-3xl font-bold text-primary mb-4">Coral Karbala Page</h1><p className="text-gray-700">Content here.</p></div>); };
export default CoralKarbala;